import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import footerStyles from './footerStyles';

// Stamped into the bundle at build time by vite.config.ts: the git tag the deploy
// was built from, or <release>+dev.<sha> on DEV. Already carries its own prefix.
const APP_RELEASE = process.env.APP_RELEASE;

function Footer() {
    const classes = footerStyles();
    const currentYear = new Date().getFullYear().toString();

    return (
        <Paper square elevation={0} className={classes.appFooter}>
            <Grid className={classes.appFooterInner}>
                {APP_RELEASE ? (
                    <Typography className={classes.version} variant="body2" component="span">
                        {APP_RELEASE}
                    </Typography>
                ) : (
                    <span />
                )}
                <Typography className={classes.subFooter} variant="body2" component="span">
                    {`Taytan Management System © ${currentYear}`}
                </Typography>
            </Grid>
        </Paper>
    );
}

export default React.memo(Footer);
